/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "products-base-pricing-delivery",
	data() {
		return {
			zoneProductBasePrices: [],
			productHeadings: [
				{
					text: "Name",
					field: "product"
				},
				{
					text: "Is Active",
					field: "isActive"
				},
				{
					text: "Zone",
					field: "zone"
				},
				{
					text: "Price",
					field: "priceAsString"
				},
				{
					text: "Effective Date",
					field: "effectiveDate"
				},
				{
					text: "Date Created",
					field: "insertedOn"
				}
			],
			zones: [],
			productTypes: [],
			productType: {},
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			actionKeys:{
				edit: "edit",
				markAsActiveInactive: "markAsActiveInactive"
			},
			productAddEditFormModal:{
				showModal: false,
				isSaving: false,
				modalId: "addEditProductModal",
				heading: "Add Product",
				product: {
					productId: null,
					name: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					price: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					erpCode: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					effectiveDate: {
						value: null,
						hasError: false,
						errorMessage: null
					},
					allowCollection: false,
					allowDelivery: false,
					allowCollectionDeliveryErrorMessage: null,
					allowCollectionDeliveryHasError: false
				},
				isUpdate: false
			},
			productMarkAsActiveInactiveModal:{
				showModal: false,
				isSaving: false,
				modalId: "markProductAsActiveInactiveModal",
				heading: "Mark Product As Active/Inactive",
				isActive: null,
				zoneProductBasePriceId: null
			},
			filterStateChanged: false,
			filter:{
				zoneId: null,
				customerSearchQuery: null,
				activeOrInactiveItems: 1
			},
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			selectedHeartbeatStatusCodeId: null
		};
	},
	methods: {
		getZoneProductBasePrices(){
			this.loading = true;
			let request = {
				searchQuery: this.filter.customerSearchQuery,
				zoneId: this.filter.zoneId,
				isActive: castingUtility.toBoolean(this.filter.activeOrInactiveItems)
			};
			productService.getZoneProductBasePrices(request).then(
				successResponse => {
					console.log("successResponse", successResponse);
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						this.zoneProductBasePrices = successResponse.data.result;
						for(let i = 0; i < this.zoneProductBasePrices.length; i++){
							this.zoneProductBasePrices[i].actions = [
								{
									name: "Edit",
									key: this.actionKeys.edit
								},
								{
									name: this.zoneProductBasePrices[i].isActive ? "Mark As Inactive" : "Mark As Active",
									key: this.actionKeys.markAsActiveInactive
								}
							];
							this.zoneProductBasePrices[i].priceAsString = currencyHelper.numberToCurrency(this.zoneProductBasePrices[i].price);
						}
						this.zoneProductBasePrices = dataTableHelper.castFieldValues(this.zoneProductBasePrices);
						this.filterStateChanged = false;
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getZones() {
			let request = {
				isActive: true
			};
			let fieldsToFilterBy = [
				{
					value: null,
					key: "description"
				}
			];
			let activeOnly = true;
			systemService.getZones(fieldsToFilterBy, request, false, activeOnly).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.zones = successResponse.data.result;
						this.zones = dataTableHelper.castFieldValues(this.zones);
						this.zones.unshift(
							{
								zoneId: 0,
								description: "All"
							});
						this.zones = $.map(this.zones,
							function (obj) {
								obj.id = obj.id || obj.zoneId;
								obj.text = obj.text || obj.description;
								return obj;
							});
						this.filter.zoneId = 0;
						this.getZoneProductBasePrices();
					}
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onFilterSearchClicked(){
			console.log("Search filter clicked");
			this.getZoneProductBasePrices();
		},
		onActiveInactiveFilterSelected(activeOrInactiveKey){
			this.filter.activeOrInactiveItems = activeOrInactiveKey;
			this.filterStateChanged = true;
			console.log("filter", this.filter);
		},
		onZoneFilterSelect(zone){
			if(this.filter.zoneId !== zone.id){
				this.filter.zoneId = zone.id;
				this.filterStateChanged = true;
			}
		},
		onProductActionClicked(actionAndData){
			console.log("actionAndData", actionAndData);
			switch(actionAndData.action){
				case this.actionKeys.edit:
					this.$router.push("/pricing/delivery/editDeliveryBasePrice/" + actionAndData.data.productId)
					break;
				case this.actionKeys.markAsActiveInactive:
					this.productMarkAsActiveInactiveModal.showModal = true;
					this.productMarkAsActiveInactiveModal.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
					this.productMarkAsActiveInactiveModal.heading = "Mark Delivery Pricing For Product As " + (this.productMarkAsActiveInactiveModal.isActive ? "Inactive" : "Active") + " - " 
						+ actionAndData.data.product + " and zone " + actionAndData.data.zone;
					this.productMarkAsActiveInactiveModal.zoneProductBasePriceId = actionAndData.data.zoneProductBasePriceId;
					break;
			}
		},
		onMarkProductActiveInactiveSelected(isActive){
			this.productMarkAsActiveInactiveModal.isActive = isActive;
			console.log("productMarkAsActiveInactiveModal.isActive", this.productMarkAsActiveInactiveModal.isActive);
		},
		onMarkAsActiveInactiveSaveClick(markAsActive){
			this.productMarkAsActiveInactiveModal.isSaving = true;
			let request = {
				zoneProductBasePriceId: this.productMarkAsActiveInactiveModal.zoneProductBasePriceId,
				isActive: markAsActive
			};
			productService.markZoneProductBasePriceAsActiveOrInactive(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.getZoneProductBasePrices();
						this.productMarkAsActiveInactiveModal.showModal = false;
						this.productMarkAsActiveInactiveModal.isActive = null;
						this.productMarkAsActiveInactiveModal.productId = null;
					}
					this.productMarkAsActiveInactiveModal.isSaving = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.productMarkAsActiveInactiveModal.isSaving = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		// onPriceInput(price){
		// 	console.log("price", this.productAddEditFormModal.product.price);
		// 	if (isNaN(this.productAddEditFormModal.product.price)) {
		// 		this.productAddEditFormModal.product.price = "";
		// 	}
		//
		// 	var formatter = new Intl.NumberFormat('en-ZA', {
		// 		style: 'currency',
		// 		currency: 'ZAR',
		// 		minimumFractionDigits: 2
		// 	});
		// 	console.log("formatter", formatter.format(this.productAddEditFormModal.product.price));
		// 	var value = formatter.format(this.productAddEditFormModal.product.price);
		// 	console.log("value", value);
		// 	this.productAddEditFormModal.product.price = value;
		// },
		onAddOrEditProductModalCloseClick(){
			this.productAddEditFormModal.showModal = false;
			this.clearProductModel();
		},
		onNewPriceDateSelect(date){
			this.productAddEditFormModal.product.effectiveDate.value = date;
		},
		setBreadcrumbs() {
			storeState.setPageTitleAction("Product Base Pricing");
			var breadcrumbs = [];
			var breadcrumbLogistics = {
				url: null,
				displayText: "Delivery"
			};
			var driverManagementBreadcrumb = {
				url: this.$route.path,
				displayText: "Product Base Pricing"
			};
			breadcrumbs.push(breadcrumbLogistics);
			breadcrumbs.push(driverManagementBreadcrumb);
			breadcrumbsStoreState.setBreadcrumbs(breadcrumbs);
		}
	},
	mounted: function () {
		this.getZones();
		this.setBreadcrumbs();
		// this.getProducts();
		
	}
};